document.addEventListener('DOMContentLoaded', function () {
  // --- Keep --aow-header-height / --aow-announcement-height accurate -----
  // These custom properties drive the fixed header's vertical offset and,
  // on every non-home page, how far #MainContent is pushed down so page
  // content (headings included) doesn't render underneath the fixed
  // header. The CSS file's :root values are just a starting guess -- the
  // header's real rendered height varies (announcement bar on/off, font
  // load, wrapping at different breakpoints), so measuring it here and
  // writing the real pixel values back onto :root keeps every page's
  // top padding correct instead of relying on a guessed constant that
  // drifts out of sync and lets titles sit under the header.
  var updateHeaderOffsetVars = function () {
    var headerEl = document.getElementById('aow-header-shell');
    var announcementEl = document.querySelector('.announcement-bar-section');
    var root = document.documentElement;

    if (headerEl) {
      root.style.setProperty('--aow-header-height', headerEl.offsetHeight + 'px');
    }
    root.style.setProperty(
      '--aow-announcement-height',
      (announcementEl ? announcementEl.offsetHeight : 0) + 'px'
    );
  };

  updateHeaderOffsetVars();
  // Re-measure once more after full load (fonts/images can still reflow
  // the header a moment after DOMContentLoaded) and on resize, since the
  // header's real height changes across breakpoints.
  window.addEventListener('load', updateHeaderOffsetVars);
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(updateHeaderOffsetVars, 150);
  });

  // --- Home page hero header overlay ------------------------------------
  var headerShell = document.getElementById('aow-header-shell');

  if (headerShell) {
    // Watch the dark marquee bar itself -- not the whole hero block -- so the
    // header switches to its solid white background right around when the
    // dark background actually ends.
    var hero = document.querySelector('[data-aow-header-clear-target]');

    // Fall back to the whole hero section if the marquee element isn't
    // present, so this doesn't silently do nothing if the block's markup
    // ever changes.
    if (!hero) {
      var headerSection = headerShell.closest('[id^="shopify-section-"]');
      hero = headerSection ? headerSection.nextElementSibling : null;
    }

    if (hero) {
      // The header itself is ~140px tall (logo row + nav row), not just a
      // 1px-high line at the very top. Clearing as soon as the marquee's
      // bottom edge passed y=0 (the very top of the viewport) meant there
      // was a window -- while the marquee's bottom was somewhere between 0
      // and the header's own height -- where the TOP of the header (icons)
      // had already scrolled clear of the dark marquee onto the white
      // "Worn by" section behind it, while the BOTTOM of the header (nav
      // links) was still over the marquee. The header was still
      // "uncleared" the whole time that gap lasted, so text stayed forced
      // white -- invisible over the part of the header that had already
      // reached the white section. Comparing against the header's own
      // bottom edge instead of 0 means the header only goes solid once the
      // marquee has cleared it ENTIRELY, top row and bottom row at once,
      // so there's no in-between moment with one row on white and one row
      // still on black. Using the header's actual bottom edge (rather than
      // just its height) also keeps this correct if the header's top offset
      // ever changes -- e.g. with an announcement bar pinned above it.
      //
      // Deliberately not throttled through requestAnimationFrame: rAF is
      // paused by the browser on a backgrounded/hidden tab, which could
      // stall this update indefinitely (and, with a ticking guard, block
      // every later scroll update too) until a frame is finally granted.
      // getBoundingClientRect on one element is cheap enough to just run
      // directly on every scroll/resize tick.
      var updateClearedState = function () {
        var rect = hero.getBoundingClientRect();
        // Compare against the header's actual bottom edge (not just its own
        // height) so this stays correct regardless of how far down the page
        // the header itself sits -- e.g. once the announcement bar above it
        // pushes the header's top offset away from 0.
        var headerBottom = headerShell.getBoundingClientRect().bottom;
        headerShell.classList.toggle('aow-hero-cleared', rect.bottom <= headerBottom);
      };

      window.addEventListener('scroll', updateClearedState, { passive: true });
      window.addEventListener('resize', updateClearedState);
      updateClearedState();
    }
  }

  // --- Flags next to countries in the country/currency selector ----------
  // The theme's own markup only prints the country name (no flag icon), so
  // build one from each option's ISO country code (already in data-value)
  // using the standard "regional indicator" emoji technique -- no images or
  // extra assets needed, and it covers any country Shopify Markets adds
  // later without more code.
  document.querySelectorAll('.country-selector .country').forEach(function (el) {
    var link = el.closest('[data-value]');
    var code = link ? link.getAttribute('data-value') : null;
    if (!code || code.length !== 2 || el.dataset.aowFlagged) return;

    var flag = code
      .toUpperCase()
      .replace(/./g, function (c) {
        return String.fromCodePoint(127397 + c.charCodeAt(0));
      });

    el.textContent = el.textContent + ' ' + flag;
    el.dataset.aowFlagged = 'true';
  });

  // --- Site-wide page-load splash ----------------------------------------
  // Shown immediately on every page, hidden as soon as the page is ready --
  // capped so a slow asset can never trap a customer behind it.
  var splash = document.getElementById('aow-load-splash');

  if (splash) {
    var minShow = 200; // avoid a single-frame flash on instant/cached loads
    var maxShow = 2000; // safety cap
    var shownAt = Date.now();
    var hidden = false;

    var hideSplash = function () {
      if (hidden) return;
      hidden = true;
      var wait = Math.max(0, minShow - (Date.now() - shownAt));
      setTimeout(function () {
        splash.classList.add('aow-load-splash--hidden');
        setTimeout(function () {
          if (splash.parentNode) splash.parentNode.removeChild(splash);
        }, 400);
      }, wait);
    };

    window.addEventListener('load', hideSplash);
    setTimeout(hideSplash, maxShow);
  }
});
